import { getMod } from 'services/hooks';
import { getModComponent } from 'services/utils';

export const BudgetingPropose = () => {
  const BudgetingProposeMC = getModComponent(
    getMod('financial')?.containers.BudgetingProposeModalProxy
  );

  return <BudgetingProposeMC />;
};
